<template>
    <div>
        <nav class="navbar navbar-default">
            <div class="container-fluid">
                <div class="navbar-header">
                    <p class="navbar-text bold">{{company.display_name}}</p>
                </div>
                <div class="btn-toolbar pull-right text-right" style="margin-top: 10px;">
                    <SelectCurrencies></SelectCurrencies>
                    <SelectLanguages></SelectLanguages>
                </div>
            </div>
        </nav>
        <div class="page-content" v-if="!notFound">
            <div class="row margin-bottom-20">
                <div class="col-xs-12 visible-xs">
                    <button
                            class="btn btn-default btn-lg btn-block margin-bottom-20"
                            @click="showPurchaseSubscriptionClientModal=true"
                    >
                        <i class="las la-shopping-cart"></i>
                        <span class="button-text">{{ $t('common.buy_subscription') }}</span>
                    </button>
                </div>
                <div class="col-xs-12 col-md-5">
                    <h1 class="h2 margin-0">{{ $t('common.calendar') }}</h1>
                </div>
                <div class="col-xs-12 hidden-xs col-md-7 text-right">
                    <button
                            class="btn btn-primary"
                            @click="showPurchaseSubscriptionClientModal=true"
                    >
                        <i class="las la-shopping-cart"></i>
                        <span class="button-text">{{ $t('common.buy_subscription') }}</span>
                    </button>
                </div>
            </div>
            <VueCal
                    :class="{ 'calendar-mobile' : isMobile }"
                    class="vuecal--blue-theme"
                    :disable-views="disableViews"
                    :locale="$i18n.locale"
                    id="vuecal"
                    :time="false"
                    :events="events"
                    events-on-month-view="short"
                    :on-event-click="onEventClick"
                    @view-change="fetchAppointments"
                    @ready="fetchAppointments"
                    :active-view="activeView"
            >

            </VueCal>
            <div style="padding-top: 10px">
                Timezone: {{getTimeZoneLocal()}}
            </div>
        </div>
        <div
                v-else
                class="alert alert-danger"
                style="margin:10px;"
                role="alert"
        >
            {{ $t('views.appointment_booking_widget.item_not_found') }}
        </div>
        <BookingClientModal
                v-if="renderBookingClientModal"
                :appointment-set-id="selectedAppointmentSetId"
                v-show="showBookingClientModal"
                :visible="showBookingClientModal"
                :country="country"
                @close-booking-client-modal="closeBookingClientModal"></BookingClientModal>
        <PurchaseSubscriptionClientModal
                v-if="renderPurchaseSubscriptionClientModal"
                v-show="showPurchaseSubscriptionClientModal"
                :visible="showPurchaseSubscriptionClientModal"
                :country="country"
                @close-purchase-subscription-modal="closePurchaseSubscriptionClientModal"></PurchaseSubscriptionClientModal>
        <SpinnerLoader v-show="loading"></SpinnerLoader>
        <div style="padding:50px;text-align:center;">
            <span class="text-muted">Powered by Respira Yoga</span>
        </div>
    </div>
</template>


<style>


    .vuecal__event-title {
        font-weight: bold;
        padding: 5px;
        color: black;
    }

    .vuecal__event {
        cursor: pointer;
        background-color: #f5f5f5;
        margin: 10px 0;
        padding: 5px;
        border-radius: 6px;
    }
    .vuecal--week-view .vuecal__time-cell {height: 300px;}

    .vuecal--month-view .vuecal__cell {height: 100px;}

    .vuecal--month-view .vuecal__cell-content {
        justify-content: flex-start;
        height: 100%;
        align-items: flex-end;
    }

    .vuecal__cell {
        padding: 0 10px;
    }

    .vuecal--month-view .vuecal__cell-date {padding: 4px;}
    .vuecal--month-view .vuecal__no-event {display: none;}
    .vuecal__event-content {
        padding: 5px 10px
    }

    .vuecal__event-content button {
        margin: 0
    }
</style>

<script>
    import VueCal from 'vue-cal'
    import 'vue-cal/dist/i18n/it.js'
    import 'vue-cal/dist/vuecal.css'
    import SpinnerLoader from "@/components/common/SpinnerLoader";
    import { isMobile } from 'mobile-device-detect';
    import {getCompanyAppointments} from "../api";
    import BookingClientModal from "../components/modal/BookingClientModal";
    import {Utils} from "../common/utils";
    import PurchaseSubscriptionClientModal from "../components/modal/PurchaseSubscriptionClientModal";
    import i18n from '../i18n'
    import {LocaleHelper} from "../common/localeHelper";
    import {getPublicCompany} from "@/api";
    import {COUNTRY_DEFAULT} from "../common/constants";
    import SelectLanguages from "../components/common/SelectLanguages";
    import SelectCurrencies from "../components/common/SelectCurrencies";
    import defaultMixin from "@/common/defaultMixin";
    export default {
        title: i18n.t('common.calendar'),
        name: "AppointmentBooking",
        mixins: [defaultMixin],
        components: {BookingClientModal, PurchaseSubscriptionClientModal, VueCal, SpinnerLoader, SelectCurrencies, SelectLanguages},
        data() {
            return {
                notFound: false,
                disableViews: isMobile ? ['years', 'year', 'month', 'week'] : ['years', 'year', 'month', 'day'],
                activeView: isMobile ? 'day' : 'week',
                hourStartMinutes: 0,
                hourEndMinutes: 24*60,
                timeCellHeight: 150,
                appointments: [],
                startDate: null,
                endDate: null,
                loading: false,
                showBookingClientModal: false,
                renderBookingClientModal: true,
                showPurchaseSubscriptionClientModal: false,
                renderPurchaseSubscriptionClientModal: true,
                selectedAppointmentSetId: 0,
                events: [],
                company: {},
                country: COUNTRY_DEFAULT
            }
        },
        async created() {
            this.company = await getPublicCompany(this.$route.params.company_username);
            if (this.$route.params.lang) {
                LocaleHelper.setLanguage(this.$route.params.lang)
            }
            this.country = this.company.country

        },
        computed: {
            isMobile: function () {
                return isMobile
            }
        },

        methods: {
            selectLang(lang) {
                LocaleHelper.setLanguage(lang);
                this.getAppointments(this.startDate, this.endDate, false);
            },
            closeBookingClientModal() {
                this.showBookingClientModal = false;
                this.getAppointments(this.startDate, this.endDate, false);

                this.$nextTick(() => {
                    this.renderBookingClientModal = false;
                    this.$nextTick(() => {
                        this.renderBookingClientModal = true;
                    });
                });
            },
            onEventClick (event) {
                if (!event.start_date_in_past && event.available) {
                    this.selectedAppointmentSetId = event.set_id;
                    this.showBookingClientModal = true;
                }

            },
            fetchAppointments ({startDate, endDate }) {
                this.startDate = startDate;
                this.endDate = endDate;
                this.getAppointments(startDate, endDate)
            },
            async getAppointments(startDate, endDate, loading = true) {
                let rates = this.$route.query.rates;
                let ratesArray = [];
                if (rates) {
                    ratesArray = rates.split(',')
                }


                this.loading = loading;
                try {
                    const calendar = document.querySelector('#vuecal .vuecal__bg');
                    calendar.scrollTo({ top: 0 });
                    let appointmentsResult = await getCompanyAppointments(this.$route.params.company_username,
                        startDate.toISOString(), endDate.toISOString(), ratesArray);
                    this.hourStartMinutes = 0;
                    this.hourEndMinutes = 24 * 60;
                    this.appointments = appointmentsResult.results;
                    this.loading = false;
                } catch (e) {
                    this.loading = false;
                    this.notFound = true;
                    console.log(e)
                }
            },
            getHourString(date){
                return Utils.getHourStringFromISOLocal(date)
            },
            getTimeZoneLocal() {
                return Utils.getTimeZoneLocal()
            },

            closePurchaseSubscriptionClientModal() {
                this.showPurchaseSubscriptionClientModal = false

                this.$nextTick(() => {
                    this.renderPurchaseSubscriptionClientModal = false;
                    this.$nextTick(() => {
                        this.renderPurchaseSubscriptionClientModal = true;
                    });
                });
            }

        },
        watch: {
            appointments(newVal) {
                let events = [];
                let minHour = 24;
                let maxHour = 0;

                newVal.forEach(appointment => {
                    let date_event = new Date(appointment.date);
                    let end_date_event = new Date(appointment.end_date);

                    let html_location = i18n.t('common.in_studio');
                    if (appointment.is_online) {
                        html_location = "<span class='badge'>ONLINE</span>"
                    } else if (appointment.location) {
                        html_location = "<a href='https://www.google.com/maps/place/" + appointment.location.latitude +","
                            +  appointment.location.longitude +  "' target=\"_blank\">" + appointment.location.name + "</a>"
                    }

                    let html_button = "";
                    if (!appointment.start_date_in_past && appointment.available) {
                        html_button = "<button class='btn-primary btn btn-block'>" +  i18n.t('common.book') + " </button>"
                    } else if (!appointment.available && !appointment.start_date_in_past) {
                        html_button = "<span class='label label-default'>" + i18n.t('views.appointment_booking_widget.max_capacity') + "</span>"
                    }

                    let event = {
                        id: appointment.id,
                        set_id: appointment.set,
                        start: date_event,
                        end: end_date_event,
                        title: appointment.rate_name,
                        available: appointment.available,
                        start_date_in_past: appointment.start_date_in_past,
                        content: "<p>"+ this.getHourString(date_event) + " - " + this.getHourString(end_date_event) +"</p><p>" + html_location + "<br>" + appointment.chaired_admin_name + "</p> " + html_button
                    };


                    events.push(event);

                    let hourStartEvent = date_event.getHours();
                    let hourEndEvent = end_date_event.getHours();
                    if (hourStartEvent < minHour) {
                        minHour = hourStartEvent
                    }

                    if (hourEndEvent < minHour) {
                        minHour = hourEndEvent
                    }

                    if (hourEndEvent > maxHour) {
                        maxHour = hourEndEvent
                    }

                    if (hourStartEvent > maxHour) {
                        maxHour = hourStartEvent
                    }

                });

                if (newVal.length === 0) {
                    minHour = 0;
                    maxHour = 0;
                }

                if (!isMobile) {

                    this.hourStartMinutes = minHour * 60;
                    this.hourEndMinutes = maxHour * 60;

                } else {
                    const calendar = document.querySelector('#vuecal .vuecal__bg');
                    console.log("scroll to" + minHour * this.timeCellHeight);
                    calendar.scrollTo({ top: minHour * this.timeCellHeight});
                }


                this.events = events;

            }
        }
    }
</script>
